import axiosIns from '@/libs/axios'

const ROOT_URL = '/finance'

export default {
  namespaced: true,
  state: {
    summary: null,
    entries: [],
    recentTrades: [],
    metaData: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    dataSave: { status: null, message: null },
  },
  getters: {
    summary: s => s.summary,
    entries: s => s.entries,
    recentTrades: s => s.recentTrades,
    metaData: s => s.metaData,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_SUMMARY(state, data) { state.summary = data },
    SET_ENTRIES(state, data) { state.entries = data || [] },
    SET_RECENT_TRADES(state, data) { state.recentTrades = data || [] },
    SET_META_DATA(state, data) { state.metaData = data },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getSummary({ commit }) {
      return axiosIns.get(`${ROOT_URL}/summary`)
        .then(response => commit('SET_SUMMARY', response.data.data))
        .catch(error => { console.error(error); commit('SET_SUMMARY', null) })
    },
    getEntries({ commit }, params = {}) {
      return axiosIns.post(`${ROOT_URL}/entries`, params)
        .then(response => {
          commit('SET_ENTRIES', response.data.data)
          commit('SET_META_DATA', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_ENTRIES', [])
          commit('SET_DATA_SAVE', { status: false, message: 'Finans hareketleri alınamadı.' })
        })
    },
    getRecentTrades({ commit }, { limit = 8 } = {}) {
      return axiosIns.get(`${ROOT_URL}/recent-trades`, { params: { limit } })
        .then(response => commit('SET_RECENT_TRADES', response.data.data))
        .catch(error => { console.error(error); commit('SET_RECENT_TRADES', []) })
    },
    createManualEntry({ commit, dispatch }, body) {
      return axiosIns.post(`${ROOT_URL}/manual-entry`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Finans hareketi kaydedildi.' })
          dispatch('getSummary')
          dispatch('getEntries', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Finans hareketi kaydedilemedi.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
  },
}
